export enum WizardModalResultType {
  ANCHORLINK,
  STRING,
  OTHER,
}

export class WizardModalResult<T, K = boolean> {
  constructor(public type: WizardModalResultType, public payload: T, public other?: K) { }
}
